import React from 'react';
import { Box } from '@mui/material';

function AgentPolicyContent({ html = '', compact = false }) {
    return (
        <Box
            className="agent-policy-content"
            sx={{
                color: 'text.primary',
                fontSize: compact ? '0.92rem' : '1rem',
                lineHeight: 1.65,
                '& h1, & h2, & h3, & h4': {
                    color: 'primary.main',
                    lineHeight: 1.25,
                    mt: compact ? 2 : 3,
                    mb: 1
                },
                '& h2:first-of-type, & h3:first-of-type': {
                    mt: 0
                },
                '& p': {
                    my: 1
                },
                '& ul, & ol': {
                    pl: 3,
                    my: 1.25
                },
                '& li': {
                    mb: 0.6
                },
                '& hr': {
                    border: 0,
                    borderTop: '1px solid',
                    borderColor: 'divider',
                    my: 2.5
                },
                '& table': {
                    width: '100%',
                    borderCollapse: 'collapse',
                    my: 2
                },
                '& th, & td': {
                    border: '1px solid',
                    borderColor: 'divider',
                    p: 1,
                    verticalAlign: 'top'
                },
                '& th': {
                    bgcolor: 'action.hover',
                    fontWeight: 700
                },
                '& a': {
                    color: 'primary.main'
                }
            }}
            dangerouslySetInnerHTML={{ __html: html || '' }}
        />
    );
}

export default AgentPolicyContent;
